import React from "react";
import BASEURL from "../../../BaseUrl";
import { SectionTitle } from "../EmployeeForm";
import { InputText } from "primereact/inputtext";
function PersonalDocuments({
  personalDocuments,
  setPersonalDocuments,
  UploadLoader,
  handleUpload,
}) {
  return (
    <section className="flex flex-col gap-3">
      <SectionTitle>Personal Documents Upload</SectionTitle>

      {personalDocuments.map((doc, index) => (
        <div
          key={index}
          className="grid grid-cols-1 md:grid-cols-3 gap-3 items-center border p-3 rounded-md"
        >
          <InputText
            value={doc.type}
            readOnly
            className="w-full px-3 py-1.5 border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
          />

          <div>
            <input
              type="file"
              accept="image/*,.pdf,.doc,.docx"
              onChange={(e) => {
                const file = e.target.files?.[0];

                handleUpload(
                  file,
                  (url) =>
                    setPersonalDocuments((prev) =>
                      prev.map((x, i) =>
                        i === index ? { ...x, fileUrl: url } : x,
                      ),
                    ),
                  `personal-${index}`,
                );
              }}
            />

            <UploadLoader id={`personal-${index}`} />
          </div>

          {doc.fileUrl ? (
            <a
              href={`${BASEURL}${doc.fileUrl}`}
              target="_blank"
              rel="noreferrer"
              className="text-blue-600 underline"
            >
              View Uploaded
            </a>
          ) : (
            <span className="text-sm text-gray-400">Not uploaded</span>
          )}
        </div>
      ))}
    </section>
  );
}

export default PersonalDocuments;
